// extracted by mini-css-extract-plugin
export default {"bodyWrapper":"PrivacyModal_bodyWrapper__92BdH","headerWrapper":"PrivacyModal_headerWrapper__ey5WP"};